import { Injectable } from '@angular/core';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SocketService {
  private socket$: WebSocketSubject<any> | null = null;
  private readonly url = environment.socketUrl;

  private connection$: Subject<any> = new Subject();

  constructor() {}

  connect(): void {
    if (!this.socket$ || this.socket$.closed) {
      this.socket$ = webSocket({
        url: this.url,
        deserializer: e => JSON.parse(e.data),
        serializer: value => JSON.stringify(value),
        closeObserver: {
          next: () => {
            this.socket$ = null;
          }
        }
      });

      this.socket$.subscribe({
        next: msg => this.connection$.next(msg),
        error: err => {
          console.error('WebSocket error:', err);
          this.socket$ = null;
        }
      });
    }
  }

  disconnect(): void {
    this.socket$?.complete();
    this.socket$ = null;
  }

  sendMessage(msg: any): void {
    this.socket$?.next(msg);
  }

  onMessage<T = any>(action: string): Observable<T> {
    return this.connection$.asObservable().pipe(
      filter((msg) => msg && msg?.action === action)
    );
  }
}
